import { useState } from 'react';
import getOffset from '@/Framework/dom/getOffset';
import { CONTENT_WRAPPER_ID } from '@/finsight/ui/common/components/Layout/constants';
import { initialPopoverData } from './constants';

interface IPopover {
  currentTriggerComponentId: string,
  offsetTop: number,
  offsetLeft: number,
}

export const usePopover = () => {
  const [popover, setPopover] = useState<IPopover>(initialPopoverData);

  const updatePopoverPosition = (component: HTMLElement, currentTriggerComponentId: string) => {
    const el = getOffset(component);
    const isCheckbox = !currentTriggerComponentId.includes('only');
    const { offsetTop: wrapperOffsetTop } = document.getElementById(CONTENT_WRAPPER_ID);

    setPopover({
      currentTriggerComponentId,
      offsetTop: el.top - 17 - wrapperOffsetTop,
      offsetLeft: el.left + (isCheckbox ? 27 : 10),
    });
  };

  const resetPopoverState = () => setPopover(initialPopoverData);

  return {
    popover,
    setPopoverState: setPopover,
    resetPopoverState,
    updatePopoverPosition,
  };
};
